import { render } from "./TheColorPicker.vue?vue&type=template&id=6afd5823&ts=true"
import script from "./TheColorPicker.vue?vue&type=script&lang=ts"
export * from "./TheColorPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__